import ResponsiveStyleSheet from "react-native-media-query";
import { theme, createResponsiveStyles } from "@clearabee/ui-library-native";
import { Platform } from "react-native";

export const { styles, ids } = ResponsiveStyleSheet.create({
  heading: createResponsiveStyles({
    base: {
      fontFamily: "ProximaBold",
    },
    medium: {
      marginBottom: theme.spacing.medium,
    },
  }),
  label:
    Platform.OS === "web"
      ? { color: theme.colors.light.base }
      : { color: theme.colors.dark.base },
  error: Platform.select({
    web: {
      position: "absolute",
      bottom: -29,
    },
    default: {
      marginBottom: -theme.spacing.xsmall,
    },
  }),
  overlay: {
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    backgroundColor: `${theme.colors.dark.base}AA`,
    zIndex: 1,
  },
  wasteDescription: {
    marginBottom: 0,
    zIndex: 1,
  },
  wasteDescriptionInput: {
    height: theme.spacing.xlarge4,
    textAlignVertical: "top",
  },
});
